<script>
import { mapState, mapGetters } from 'vuex'
import drushim_lodash from 'lodash'
import TextField from '@/components/Forms/Form_Fields/TextField'
import PhoneNumberField from '@/components/Forms/Form_Fields/PhoneNumberField'
import EmailField from '@/components/Forms/Form_Fields/EmailField'
import PasswordField from '@/components/Forms/Form_Fields/PasswordField'
import ThankYouDialog from '@/components/Dialogs/ThankYouDialog/ThankYouDialog'
import CategorySelectDrop from '@/components/Forms/Form_Fields/CategorySelectDrop'
// import RegionSelect from '@/components/Forms/Form_Fields/RegionSelect'
import TermsField from '@/components/Forms/Form_Fields/TermsField'
import RadioSelect from '@/components/Forms/Form_Fields/RadioSelect'
import SelectCv from '@/components/Forms/Form_Fields/SelectCv'
import SignUpForm from '@/components/Forms/SignUpForm.vue'
import StepBack from '@/components/CvWizard/StepBack'

import UserPersonalDetails from '@/components/Candidates/UserDetails/UserPersonalDetails'
import UserPersonalDetailsEdit from '@/components/Candidates/UserDetails/UserPersonalDetailsEdit'

import CategorySelect from '@/components/Forms/Form_Fields/CategorySelect'
import LocationFieldNew from '@/components/Forms/Form_Fields/LocationFieldNew'

export default {
  components: {
    TextField,
    PhoneNumberField,
    EmailField,
    PasswordField,
    ThankYouDialog,
    LocationFieldNew,
    CategorySelectDrop,
    CategorySelect,
    TermsField,
    // RegionSelect,
    RadioSelect,
    UserPersonalDetails,
    UserPersonalDetailsEdit,
    SelectCv,
    SignUpForm,
    StepBack
  },
  props: {
    stepContent: {
      type: Object
    },
    stepNumber: {
      type: [String, Number],
      required: false,
      default: 1
    },
    step: {
      type: Object
    }
  },
  data() {
    return {
      yearRange: drushim_lodash.range(
        [new Date().getFullYear()],
        new Date().getFullYear() - 100,
        [-1]
      )
    }
  },
  computed: {
    stepHeader() {
      return this.stepContent.Keys[1].KeyValue.Value
    },
    isUserLogged() {
      return this.auth.loggedIn
    },
    ...mapState({
      auth: state => state.auth,
      // categories: state => state.homeDrushim.allCategories,
      // categoriesText: state => state.homeDrushim.allSubCategories,
      initialized: state => state.initializedCVW
    }),
    ...mapGetters({
      isRegisteredSmartAlerts: 'SmartAgentActive',
      getUserCvFiles: 'getUserCvFiles',
      getCVWStepData: 'getCVWStepData',
      isStepAvailable: 'isStepAvailable',
      getCurrentCVCode: 'getCurrentCVCode',
      isLogged: 'isLogged'
    }),

    userCvNumber() {
      return !drushim_lodash.isNil(this.getUserCvFiles)
        ? Object.keys(this.getUserCvFiles).length
        : 0
    },
    stepData() {
      const currentStep = this.$router.currentRoute.params.id
      return this.getCVWStepData(currentStep)
    },
    isAvailable() {
      const currentStep = this.$router.currentRoute.params.id
      if (!this.isStepAvailable(currentStep)) {
        if (currentStep == 1) {
          return this.isInitialized
        }
        return this.goToRoute(1)
      }

      return true
    },

     isInitialized() {
      if (!this.initialized) {
         this.$store.dispatch('loadCVWContent')
      }
      return true
    }
  },
  methods: {
    goToRoute(number) {
      let page = `/קורות-חיים/${number}/`
      this.$router.push(page)
    }
  }
}
</script>
